module.exports = __webpack_public_path__ + "img/q.1022322d.png";